const DELIMITER = ':';

export const ScopeKey = {
  DELIMITER,
  join: (...parts: (string | number)[]) => parts.join(DELIMITER),
};
